module.exports = __webpack_public_path__ + "img/macStep2.8b250488.png";